import { format } from 'date-fns';

export const getTodayDate = (): string => {
  return format(new Date(), 'yyyy-MM-dd');
};
